import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseUrl, api_service_path } from './utils'

export const userActions = createApi({
    reducerPath: "userApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/${api_service_path.auth}`,
        prepareHeaders: (headers) => {
            const current_user = localStorage.getItem("current_user") ? JSON.parse(localStorage.getItem("current_user")) : null
            if (current_user?.token) {
                headers.set(
                    "Authorization",
                    `Bearer ${current_user.token}`
                )
            }
            return headers
        }
    }),
    endpoints: (builder) => ({
        userRegister: builder.mutation({
            query: ({ firstname, lastname, email, password, meta_data }) => ({
                url: `/create`,
                method: "POST",
                body: {
                    firstname,
                    lastname,
                    email,
                    password,
                    meta_data
                }
            }),
            invalidatesTags: ["createUser"]
        }),
        userLogin: builder.mutation({
            query: ({ email, password }) => ({
                url: `/login`,
                params: { email, password },
                method: "POST",
                body: {
                    email,
                    password
                }
            }),
            invalidatesTags: ["loginUser"]
        }),
        getUserPrivileges: builder.query({
            query: ({ designation, platform_id }) => ({
                url: `${api_service_path.user}/privilages/${designation}/${platform_id}`,
                method: "GET"
            })
        }),
        checkUserPlatform: builder.query({
            query: ({ user_email }) => ({
                url: `/check_user_platform/${user_email}`,
                method: "GET"
            })
        }),
        resetPassword: builder.mutation({
            query: ({ email, new_password }) => ({
                url: `/reset_password`,
                params: { email, new_password },
                method: "PUT",
                body: {
                    email,
                    new_password
                }
            })
        }),
        connectWithUs: builder.mutation({
            query: (data) => ({
                url: "/api/user/connect",
                method: "POST",
                body: data
            })
        })
    })
})

export const {
    usePrefetch,
    useUserRegisterMutation,
    useUserLoginMutation,
    useLazyGetUserPrivilegesQuery,
    useLazyCheckUserPlatformQuery,
    useResetPasswordMutation,
    useConnectWithUsMutation
} = userActions